import { render } from "./MainWeek.vue?vue&type=template&id=00addcf6"
import script from "./MainWeek.vue?vue&type=script&lang=js"
export * from "./MainWeek.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__